import {Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false
})
export class CheckboxComponent implements OnInit, OnChanges {
  @Input() checked: boolean | 'indeterminate' = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  @HostBinding('class.checked') _checked = false;
  @HostBinding('class.indeterminate') _indeterminate = false;

  @HostListener('click') click() {
    this.checked = this.checked !== true;
    this.checkedChange.emit(this.checked);
    this.setClasses();
  }

  ngOnInit() {
    this.setClasses();
  }

  ngOnChanges(): void {
    this.setClasses();
  }

  private setClasses() {
    this._checked = this.checked === true;
    this._indeterminate = this.checked === 'indeterminate';
  }
}
